import eventbus from '../eventBus'
export default {
    inject: ['$validator'],
    data() {
      return {
        hasError: false,
        errorMessage: ''
      }
    },
    methods: {
        getError(fieldName) {
            return this.errors.first(fieldName)
        },
        showLoading() {
          eventbus.$emit('ui-action:loading', true)
        },
        hideLoading() {
          eventbus.$emit('ui-action:loading', false)
        },
        showError(errorMessage) {
          this.hasError = true
          this.errorMessage = errorMessage
        }
    }
}